(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collection-card-image"] && !Shopify.designMode) return;
  try {
    // Print Depot: hover slideshow for the bento collection tiles.
  //
  // Mirrors the category card behaviour. The card's own image is the resting
  // state, so leaving the tile simply deactivates every slide rather than
  // holding one — that way a tile always settles back to the picture the
  // merchant chose for it.
  (() => {
    const attach = (card) => {
      if (card.dataset.pdBentoSlides) return;

      const slides = Array.from(card.querySelectorAll('.pd-bento-slide'));
      if (slides.length < 2) return;

      card.dataset.pdBentoSlides = 'on';

      const FADE = 620;
      const INTERVAL = 2400;
      const FIRST = Math.round(INTERVAL * 0.45);

      let index = -1;
      let startId = null;
      let cycleId = null;
      let settleId = null;

      // is-previous holds the outgoing slide opaque underneath the incoming
      // one, then drops it once the arrival has finished. Fading both at once
      // dips through a washed-out midpoint on opaque photographs.
      const goTo = (next) => {
        if (next === index) return;
        const outgoing = index >= 0 ? slides[index] : null;
        index = next;

        for (const slide of slides) {
          if (slide !== outgoing) slide.classList.remove('is-previous');
        }
        if (outgoing) {
          outgoing.classList.remove('is-active');
          outgoing.classList.add('is-previous');
        }
        slides[index].classList.add('is-active');

        clearTimeout(settleId);
        settleId = setTimeout(() => outgoing?.classList.remove('is-previous'), FADE);
      };

      const advance = () => goTo(index < 0 ? 0 : (index + 1) % slides.length);

      const start = () => {
        if (startId || cycleId) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        startId = setTimeout(() => {
          startId = null;
          advance();
          cycleId = setInterval(advance, INTERVAL);
        }, FIRST);
      };

      const stop = () => {
        clearTimeout(startId);
        clearInterval(cycleId);
        clearTimeout(settleId);
        startId = null;
        cycleId = null;
        index = -1;
        for (const slide of slides) slide.classList.remove('is-active', 'is-previous');
      };

      card.addEventListener('pointerenter', start);
      card.addEventListener('pointerleave', stop);
      card.addEventListener('focusin', start);
      card.addEventListener('focusout', stop);
    };

    const scan = () => {
      for (const slides of document.querySelectorAll('.pd-bento-slides')) {
        const card = slides.closest('.collection-card');
        if (card) attach(card);
      }
    };

    scan();
    document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_pd-category-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const attach = (card) => {
      if (card.dataset.pdSlideshow) return;

      const slides = Array.from(card.querySelectorAll('.pd-category-card__slide'));
      if (slides.length < 2) return;

      card.dataset.pdSlideshow = 'on';

      // Timings come from CSS custom properties on the section, so they stay
      // adjustable from the theme editor without touching this file.
      const readMs = (prop, fallback) => {
        const value = parseFloat(getComputedStyle(card).getPropertyValue(prop));
        return Number.isFinite(value) ? value : fallback;
      };

      const interval = readMs('--pd-slide-interval', 2400);
      const fade = readMs('--pd-slide-fade', 900);
      const firstAdvance = Math.round(interval * 0.45);

      let index = 0;
      let startId = null;
      let cycleId = null;
      let settleId = null;

      // is-active drives the cross-fade. is-previous is also tracked, but only
      // fill mode styles it — see the stylesheet above.
      const goTo = (next) => {
        if (next === index) return;

        const outgoing = slides[index];
        index = next;

        for (const slide of slides) {
          if (slide !== outgoing) slide.classList.remove('is-previous');
        }

        outgoing.classList.remove('is-active');
        outgoing.classList.add('is-previous');
        slides[index].classList.add('is-active');

        clearTimeout(settleId);
        settleId = setTimeout(() => outgoing.classList.remove('is-previous'), fade);
      };

      const advance = () => goTo((index + 1) % slides.length);

      const start = () => {
        if (startId || cycleId) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        startId = setTimeout(() => {
          startId = null;
          advance();
          cycleId = setInterval(advance, interval);
        }, firstAdvance);
      };

      const stop = () => {
        clearTimeout(startId);
        clearInterval(cycleId);
        startId = null;
        cycleId = null;
        goTo(0);
      };

      card.addEventListener('pointerenter', start);
      card.addEventListener('pointerleave', stop);
      card.addEventListener('focusin', start);
      card.addEventListener('focusout', stop);
    };

    const scan = () => {
      for (const card of document.querySelectorAll('.pd-category-card')) attach(card);
    };

    scan();
    document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

})();
